export function createPreviewApi(token,onExpired) {
  async function request(path,{method='GET',body,csrf}={}) {
    const controller=new AbortController();const timer=window.setTimeout(()=>controller.abort(),20000);
    try {
      const response=await fetch(`/admin/api/account-preview${path}`,{method,credentials:'include',cache:'no-store',referrerPolicy:'no-referrer',signal:controller.signal,
        headers:{Accept:'application/json','Content-Type':'application/json','X-Account-Preview':token,...(csrf?{[csrf.headerName]:csrf.token}:{})},body:body===undefined?undefined:JSON.stringify(body)});
      let data={};try{data=await response.json();}catch{}
      if(!response.ok) {
        if(response.status===401 || response.status===403)onExpired();
        const error=new Error(response.status===401?'Просмотр завершён. Откройте кабинет заново из админки.':response.status===404?'Заказ недоступен выбранной почте.':'Источник данных временно недоступен.');error.status=response.status;throw error;
      }
      return data;
    } finally {window.clearTimeout(timer);}
  }
  return {
    metadata:()=>request('/session'),
    getAccountOrders:page=>request(`/visoria/orders?page=${encodeURIComponent(page)}`),
    getBotAccountOrders:cursor=>request(`/bots/orders${cursor?`?cursor=${encodeURIComponent(cursor)}`:''}`),
    getHistoryOrder:async order=>{
      const data=await request(order.source==='bot'?`/bots/orders/${encodeURIComponent(order.shop)}/${encodeURIComponent(order.billId)}`:`/visoria/orders/${encodeURIComponent(order.orderId)}`);
      return data.order;
    },
    getFavorites:async()=>{const data=await request('/visoria/favorites');return data.items;},
    close:async()=>{const csrf=await request('/csrf');return request('/session',{method:'DELETE',csrf});},
  };
}
